import {
  Alert,
  Box,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import {
  CalendarMonth as CalendarIcon,
  Warning as WarningIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import React from "react";

interface CalendarEventErrorProps {
  activityId: number;
  activityName?: string;
  onCreateNewMeeting?: () => void;
}

const CalendarEventError: React.FC<CalendarEventErrorProps> = ({
  activityId,
  activityName,
  onCreateNewMeeting,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        bgcolor: "warning.light",
        color: "warning.contrastText",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "warning.main",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: "absolute",
          top: -20,
          right: -20,
          width: 80,
          height: 80,
          borderRadius: "50%",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />

      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
          <WarningIcon sx={{ fontSize: 32, color: "warning.main" }} />
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Kalenderhändelse hittades inte
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
          Kalenderhändelsen som var kopplad till denna aktivitet finns inte längre i Outlook. 
          Den kan ha tagits bort eller flyttats av organisatören.
        </Typography>

        <Alert 
          severity="info" 
          sx={{ 
            mb: 3,
            bgcolor: "rgba(25, 118, 210, 0.08)",
            "& .MuiAlert-icon": {
              color: "info.main",
            }
          }}
        >
          <Typography variant="body2">
            Aktiviteten finns kvar och all information är intakt. Bara kalenderlänken fungerar inte längre.
          </Typography>
        </Alert>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {onCreateNewMeeting && (
            <Button
              onClick={onCreateNewMeeting}
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                bgcolor: "primary.main",
                color: "white",
                fontWeight: "medium",
                "&:hover": {
                  bgcolor: "primary.dark",
                },
              }}
            >
              Skapa nytt möte
            </Button>
          )}
          
          <Button
            onClick={() => {
              // Open Outlook calendar in new tab
              window.open("https://outlook.office365.com/calendar", "_blank", "noopener,noreferrer");
            }}
            variant="outlined"
            startIcon={<CalendarIcon />}
            sx={{
              borderColor: "primary.main",
              color: "primary.main",
              fontWeight: "medium",
              "&:hover": {
                borderColor: "primary.dark",
                bgcolor: "primary.50",
              },
            }}
          >
            Öppna Outlook
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CalendarEventError;